// helpers/constants
import * as G from '../../helpers';
import { ENUMS } from '../../constants/enums';
//////////////////////////////////////////////////

const DASHBOARD_TYPE_FLEET_GENERAL = 'FLEET_GENERAL';
const DASHBOARD_TYPE_FLEET_TRAILER = 'FLEET_TRAILER';
const DASHBOARD_TYPE_FLEET_ACCOUNTING = 'FLEET_ACCOUNTING';

const DAY_3 = 3;
const DAY_7 = 7;
const DAY_14 = 14;
const DAY_30 = 30;
const DAY_RANGE = 'RANGE';

const RANGE_TYPE_DAYS = 'DAYS';
const RANGE_TYPE_YEARS = 'YEARS';
const RANGE_TYPE_MONTHS = 'MONTHS';

const dataRangeEnumLocale = {
  [ENUMS.ENUM_FROM_ZERO_TO_SEVEN_DAYS]: G.getEnumLocale(ENUMS.ENUM_FROM_ZERO_TO_SEVEN_DAYS),
  [ENUMS.ENUM_FROM_SEVEN_TO_FOURTEEN_DAYS]: G.getEnumLocale(ENUMS.ENUM_FROM_SEVEN_TO_FOURTEEN_DAYS),
  [ENUMS.ENUM_FROM_FOURTEEN_TO_TWENTY_ONE_DAYS]: G.getEnumLocale(ENUMS.ENUM_FROM_FOURTEEN_TO_TWENTY_ONE_DAYS),
  [ENUMS.ENUM_MORE_THAN_TWENTY_ONE_DAYS]: G.getEnumLocale(ENUMS.ENUM_MORE_THAN_TWENTY_ONE_DAYS),
};

const CHART_COLORS = {
  white: '#ffffff',
  grey1: '#a6a5a9',
  grey2: '#989898',
  grey3: '#EAEAEA',
  blue1: '#4880FF',
  blue2: '#8280FF',
  blue3: '#8884d8',
  green1: '#00B69B',
  PIE_BAR_COLORS: [
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
  ],
  RADIAL_BAR_COLORS: [
    '#8884d8',
    '#83a6ed',
    '#8dd1e1',
    '#82ca9d',
    '#a4de6c',
    '#d0ed57',
    '#ffc658',
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
  ],
  BAR_COLORS: [
    '#67b7dc',
    '#6794dc',
    '#6770dc',
    '#8067dc',
    '#a367dc',
    '#c767dc',
    '#dc67ce',
    '#dc67ab',
    '#dc6788',
    '#dc6967',
    '#dc8c67',
    '#dcaf67',
    '#dcd267',
    '#c3dc67',
    '#a0dc67',
    '#7ddc66',
    '#67dc75',
    '#67dc98',
    '#67dcbb',
    '#67dadc',
  ],
};

// TODO: not added to locale API
const TITLES_MAP = {
  own: G.getWindowLocale('titles:own', 'Own'),
  trip: G.getWindowLocale('titles:trip', 'Trip'),
  toll: G.getWindowLocale('titles:toll', 'Toll'),
  fuel: G.getWindowLocale('titles:fuel', 'Fuel'),
  order: G.getWindowLocale('titles:order', 'Order'),
  drops: G.getWindowLocale('titles:drops', 'Drops'),
  vendor: G.getWindowLocale('titles:vendor', 'Vendor'),
  booked: G.getWindowLocale('titles:booked', 'Booked'),
  pickups: G.getWindowLocale('titles:pickups', 'Pickups'),
  payroll: G.getWindowLocale('titles:payroll', 'Payroll'),
  covered: G.getWindowLocale('titles:covered', 'Covered'),
  vacation: G.getWindowLocale('titles:vacation', 'Vacation'),
  canceled: G.getWindowLocale('titles:canceled', 'Canceled'),
  noDriver: G.getWindowLocale('titles:noDriver', 'No Driver'),
  newLoads: G.getWindowLocale('titles:newLoads', 'New Loads'),
  delivered: G.getWindowLocale('titles:delivered', 'Delivered'),
  orderTrip: G.getWindowLocale('titles:orderTrip', 'Order/Trip'),
  inTransit: G.getWindowLocale('titles:inTransit', 'In Transit'),
  latePercent: G.getWindowLocale('titles:latePercent', 'Late %'),
  needALoad: G.getWindowLocale('titles:needALoad', 'Need a Load'),
  tripStatus: G.getWindowLocale('titles:tripStatus', 'Trip Status'),
  ordersTotal: G.getWindowLocale('titles:ordersTotal', 'Orders Total'),
  orderStatus: G.getWindowLocale('titles:orderStatus', 'Order Status'),
  marginTotal: G.getWindowLocale('titles:marginTotal', 'Margin Total'),
  issuesFound: G.getWindowLocale('titles:issues-found', 'Issues Found'),
  lateForDrop: G.getWindowLocale('titles:lateForDrop', 'Late for Drop'),
  onTimePercentS: G.getWindowLocale('titles:onTimePercentS', 'On Time %'),
  outOfService: G.getWindowLocale('titles:outOfService', 'Out Of Service'),
  expensesTotal: G.getWindowLocale('titles:expensesTotal', 'Expenses Total'),
  activeDrivers: G.getWindowLocale('titles:activeDrivers', 'Active Drivers'),
  lateForPickUp: G.getWindowLocale('titles:lateForPickUp', 'Late for PickUp'),
  fuelTollSpend: G.getWindowLocale('titles:fuelTollSpend', 'Fuel/Toll Spend'),
  days: G.getWindowLocale('titles:days', 'days', { caseAction: 'lowerCase' }),
  expectedProfit: G.getWindowLocale('titles:expectedProfit', 'Expected Profit'),
  expectedIncome: G.getWindowLocale('titles:expectedIncome', 'Expected Income'),
  ordersZeroRate: G.getWindowLocale('titles:ordersZeroRate', 'Orders Zero Rate'),
  issuesByVendor: G.getWindowLocale('titles:issuesByVendor', 'Issues By Vendor'),
  orderRatesTotal: G.getWindowLocale('titles:orderRatesTotal', 'Order Rates Total'),
  payrollPerCharge: G.getWindowLocale('titles:payrollPerCharge', 'Payroll Per Charge'),
  averageIssuesAge: G.getWindowLocale('titles:averageIssuesAge', 'Average Issues Age'),
  trailersByCarrier: G.getWindowLocale('titles:trailersByCarrier', 'Trailers By Carrier'),
  availableTrailers: G.getWindowLocale('titles:available-trailers', 'Available Trailers'),
  ordersNotInvoiced: G.getWindowLocale('titles:ordersNotInvoiced', 'Orders Not Invoiced'),
  fleetServiceTotal: G.getWindowLocale('titles:fleetServiceTotal', 'Fleet Service Total'),
  inServiceTrailers: G.getWindowLocale('titles:inServiceTrailers', 'In Service Trailers'),
  fromLast: G.getWindowLocale('titles:from-last', 'from last', { caseAction: 'lowerCase' }),
  trailersByLocation: G.getWindowLocale('titles:trailersByLocation', 'Trailers By Location'),
  trailersByIdleTime: G.getWindowLocale('titles:trailersByIdleTime', 'Trailers By Idle Time'),
  driversAvailability: G.getWindowLocale('titles:driversAvailability', 'Drivers Availability'),
  carrierInvoiceTotal: G.getWindowLocale('titles:carrierInvoiceTotal', 'Carrier Invoice Total'),
  fromSelectedRange: G.getWindowLocale('titles:from-selected-range', 'from selected date range'),
  completedInspections: G.getWindowLocale('titles:completedInspections', 'Completed Inspections'),
  carrierInvoiceStatus: G.getWindowLocale('titles:carrierInvoiceStatus', 'Carrier Invoice Status'),
  customerInvoiceStatus: G.getWindowLocale('titles:customerInvoiceStatus', 'Customer Invoice Status'),
  averageInspectionTime: G.getWindowLocale('titles:averageInspectionTime', 'Average Inspection Time'),
  carrierInvoicePerMode: G.getWindowLocale('titles:carrierInvoicePerMode', 'Carrier Invoice per Mode'),
  customerInvoicePerMode: G.getWindowLocale('titles:customerInvoicePerMode', 'Customer Invoice per Mode'),
  fromYesterday: G.getWindowLocale('titles:fromYesterday', 'from yesterday', { caseAction: 'lowerCase' }),
  openedIssuesByPriority: G.getWindowLocale('titles:openedIssuesByPriority', 'Opened Issues By Priority'),
  inOutOfServiceTrailers: G.getWindowLocale('titles:inOutOfServiceTrailers', 'In/Out Of Service Trailers'),
  averageTrailersIdleTime: G.getWindowLocale('titles:average-trailers-idle-time', 'Average Trailers Idle Time'),
};

// General top group
const CHART_TYPE_TOTAL_CLOS = 'TOTAL_CLOS';
const CHART_TYPE_TOTAL_MARGIN = 'TOTAL_MARGIN';
const CHART_TYPE_TOTAL_OF_CLO_RATES = 'TOTAL_OF_CLO_RATES';
const CHART_TYPE_TOTAL_ACTIVE_DRIVERS_TODAY = 'TOTAL_ACTIVE_DRIVERS_TODAY';
// General main group
const CHART_TYPE_CLO_AVERAGE_RATE_PER_MILE = 'CLO_AVERAGE_RATE_PER_MILE';
const CHART_TYPE_TEL_AVERAGE_RATE_PER_MILE = 'TEL_AVERAGE_RATE_PER_MILE';
const CHART_TYPE_CLO_TEL_AVERAGE_RATE_PER_MILE = 'CLO_TEL_AVERAGE_RATE_PER_MILE';
const CHART_TYPE_ON_TIME_PERCENT_PICKUP_AND_DROP = 'ON_TIME_PERCENT_PICKUP_AND_DROP';
// General right group
const CHART_TYPE_FUEL_AND_TOLL = 'FUEL_AND_TOLL';
const CHART_TYPE_TOTAL_EXPENSES = 'TOTAL_EXPENSES';
const CHART_TYPE_TELS_BY_STATUS = 'TELS_BY_STATUS';
const CHART_TYPE_CLOS_BY_STATUS = 'CLOS_BY_STATUS';
const CHART_TYPE_ALLOCATION_FOR_DRIVERS = 'ALLOCATION_FOR_DRIVERS';
//
const GENERAL_TOP_GROUP = [
  CHART_TYPE_TOTAL_CLOS,
  CHART_TYPE_TOTAL_MARGIN,
  CHART_TYPE_TOTAL_OF_CLO_RATES,
  CHART_TYPE_TOTAL_ACTIVE_DRIVERS_TODAY,
];

const GENERAL_MAIN_GROUP = [
  CHART_TYPE_CLO_AVERAGE_RATE_PER_MILE,
  CHART_TYPE_TEL_AVERAGE_RATE_PER_MILE,
  CHART_TYPE_CLO_TEL_AVERAGE_RATE_PER_MILE,
  CHART_TYPE_ON_TIME_PERCENT_PICKUP_AND_DROP,
];

const GENERAL_RIGHT_GROUP = [
  CHART_TYPE_FUEL_AND_TOLL,
  CHART_TYPE_TOTAL_EXPENSES,
  CHART_TYPE_TELS_BY_STATUS,
  CHART_TYPE_CLOS_BY_STATUS,
  CHART_TYPE_ALLOCATION_FOR_DRIVERS,
];

const generalGroupCallOrder = [
  GENERAL_TOP_GROUP,
  GENERAL_MAIN_GROUP,
  GENERAL_RIGHT_GROUP,
];

// Accounting top group 1
const CHART_TYPE_TOTAL_PAYROLLS = 'TOTAL_PAYROLLS';
const CHART_TYPE_TOTAL_CLO_INVOICES = 'TOTAL_CLO_INVOICES';
const CHART_TYPE_TOTAL_FLEET_SERVICE = 'TOTAL_FLEET_SERVICE';
const CHART_TYPE_TOTAL_EXPECTED_PROFIT = 'TOTAL_EXPECTED_PROFIT';
// Accounting top group 2
const CHART_TYPE_TOTAL_FUEL = 'TOTAL_FUEL';
const CHART_TYPE_TOTAL_TOLL = 'TOTAL_TOLL';
const CHART_TYPE_TOTAL_CARRIER_INVOICE = 'TOTAL_CARRIER_INVOICE';
const CHART_TYPE_TOTAL_CLOS_WITH_ZERO_RATE = 'TOTAL_CLOS_WITH_ZERO_RATE';
// Accounting main group
const CHART_TYPE_PAYROLLS = 'PAYROLLS';
const CHART_TYPE_CLO_INVOICES_PER_MODE = 'CLO_INVOICES_PER_MODE';
const CHART_TYPE_CARRIER_INVOICES_PER_MODE = 'CARRIER_INVOICES_PER_MODE';
// Accounting right group
const CHART_TYPE_NOT_INVOICED_CLOS = 'NOT_INVOICED_CLOS';
const CHART_TYPE_PAYROLLS_PER_CHARGE = 'PAYROLLS_PER_CHARGE';
const CHART_TYPE_CLO_INVOICE_STATUSES = 'CLO_INVOICE_STATUSES';
const CHART_TYPE_CARRIER_INVOICE_STATUSES = 'CARRIER_INVOICE_STATUSES';

const ACCOUNTING_TOP_GROUP_1 = [
  CHART_TYPE_TOTAL_PAYROLLS,
  CHART_TYPE_TOTAL_CLO_INVOICES,
  CHART_TYPE_TOTAL_FLEET_SERVICE,
  CHART_TYPE_TOTAL_EXPECTED_PROFIT,
];

const ACCOUNTING_TOP_GROUP_2 = [
  CHART_TYPE_TOTAL_FUEL,
  CHART_TYPE_TOTAL_TOLL,
  CHART_TYPE_TOTAL_CARRIER_INVOICE,
  CHART_TYPE_TOTAL_CLOS_WITH_ZERO_RATE,
];

const ACCOUNTING_MAIN_GROUP = [
  CHART_TYPE_PAYROLLS,
  CHART_TYPE_CLO_INVOICES_PER_MODE,
  CHART_TYPE_CARRIER_INVOICES_PER_MODE,
];

const ACCOUNTING_RIGHT_GROUP = [
  CHART_TYPE_NOT_INVOICED_CLOS,
  CHART_TYPE_PAYROLLS_PER_CHARGE,
  CHART_TYPE_CLO_INVOICE_STATUSES,
  CHART_TYPE_CARRIER_INVOICE_STATUSES,
];
// Here order defines a call order
const accountingGroupCallOrder = [
  ACCOUNTING_TOP_GROUP_1,
  ACCOUNTING_TOP_GROUP_2,
  ACCOUNTING_MAIN_GROUP,
  ACCOUNTING_RIGHT_GROUP,
];

// Trailers top group 1
const CHART_TYPE_TOTAL_AVAILABLE_TRAILERS = 'TOTAL_AVAILABLE_TRAILERS';
const CHART_TYPE_TOTAL_IN_SERVICE_TRAILERS = 'TOTAL_IN_SERVICE_TRAILERS';
const CHART_TYPE_AVERAGE_TRAILERS_IDLE_TIME = 'AVERAGE_TRAILERS_IDLE_TIME';
const CHART_TYPE_TOTAL_OUT_OF_SERVICE_TRAILERS = 'TOTAL_OUT_OF_SERVICE_TRAILERS';
// Trailers top group 2
const CHART_TYPE_TOTAL_ISSUES_FOUND = 'TOTAL_ISSUES_FOUND';
const CHART_TYPE_AVERAGE_ISSUES_AGE = 'AVERAGE_ISSUES_AGE';
const CHART_TYPE_AVERAGE_INSPECTION_TIME = 'AVERAGE_INSPECTION_TIME';
const CHART_TYPE_TOTAL_COMPLETED_INSPECTIONS = 'TOTAL_COMPLETED_INSPECTIONS';
// Trailers main group
const CHART_TYPE_TRAILERS_BY_LOCATION = 'TRAILERS_BY_LOCATION';
const CHART_TYPE_TRAILERS_BY_IDLE_TIME = 'TRAILERS_BY_IDLE_TIME';
const CHART_TYPE_IN_OR_OUT_OF_SERVICE_TRAILERS = 'IN_OR_OUT_OF_SERVICE_TRAILERS';
// Trailers right group
const CHART_TYPE_ISSUES_BY_VENDOR = 'ISSUES_BY_VENDOR';
const CHART_TYPE_TRAILERS_BY_CARRIER = 'TRAILERS_BY_CARRIER';
const CHART_TYPE_OPENED_ISSUES_BY_PRIORITY = 'OPENED_ISSUES_BY_PRIORITY';

const TRAILERS_TOP_GROUP_1 = [
  CHART_TYPE_TOTAL_AVAILABLE_TRAILERS,
  CHART_TYPE_TOTAL_IN_SERVICE_TRAILERS,
  CHART_TYPE_AVERAGE_TRAILERS_IDLE_TIME,
  CHART_TYPE_TOTAL_OUT_OF_SERVICE_TRAILERS,
];

const TRAILERS_TOP_GROUP_2 = [
  CHART_TYPE_TOTAL_ISSUES_FOUND,
  CHART_TYPE_AVERAGE_ISSUES_AGE,
  CHART_TYPE_AVERAGE_INSPECTION_TIME,
  CHART_TYPE_TOTAL_COMPLETED_INSPECTIONS,
];

const TRAILERS_MAIN_GROUP = [
  CHART_TYPE_TRAILERS_BY_LOCATION,
  CHART_TYPE_TRAILERS_BY_IDLE_TIME,
  CHART_TYPE_IN_OR_OUT_OF_SERVICE_TRAILERS,
];

const TRAILERS_RIGHT_GROUP = [
  CHART_TYPE_ISSUES_BY_VENDOR,
  CHART_TYPE_TRAILERS_BY_CARRIER,
  CHART_TYPE_OPENED_ISSUES_BY_PRIORITY,
];
// Here order defines a call order
const trailersGroupCallOrder = [
  TRAILERS_TOP_GROUP_1,
  TRAILERS_TOP_GROUP_2,
  TRAILERS_RIGHT_GROUP,
  [TRAILERS_MAIN_GROUP[0]],
  [TRAILERS_MAIN_GROUP[1]],
  [TRAILERS_MAIN_GROUP[2]],
];

const dashboardGroupCallMap = {
  [DASHBOARD_TYPE_FLEET_GENERAL]: generalGroupCallOrder,
  [DASHBOARD_TYPE_FLEET_TRAILER]: trailersGroupCallOrder,
  [DASHBOARD_TYPE_FLEET_ACCOUNTING]: accountingGroupCallOrder,
};

export {
  DAY_3,
  DAY_7,
  DAY_14,
  DAY_30,
  DAY_RANGE,
  TITLES_MAP,
  CHART_COLORS,
  RANGE_TYPE_DAYS,
  RANGE_TYPE_YEARS,
  RANGE_TYPE_MONTHS,
  dataRangeEnumLocale,
  DASHBOARD_TYPE_FLEET_GENERAL,
  DASHBOARD_TYPE_FLEET_TRAILER,
  DASHBOARD_TYPE_FLEET_ACCOUNTING,
  // Chart types
  dashboardGroupCallMap,
  // General top group
  CHART_TYPE_TOTAL_CLOS,
  CHART_TYPE_TOTAL_MARGIN,
  CHART_TYPE_TOTAL_OF_CLO_RATES,
  CHART_TYPE_TOTAL_ACTIVE_DRIVERS_TODAY,
  // General large group
  CHART_TYPE_CLO_AVERAGE_RATE_PER_MILE,
  CHART_TYPE_TEL_AVERAGE_RATE_PER_MILE,
  CHART_TYPE_CLO_TEL_AVERAGE_RATE_PER_MILE,
  CHART_TYPE_ON_TIME_PERCENT_PICKUP_AND_DROP,
  // General right group
  CHART_TYPE_FUEL_AND_TOLL,
  CHART_TYPE_TOTAL_EXPENSES,
  CHART_TYPE_TELS_BY_STATUS,
  CHART_TYPE_CLOS_BY_STATUS,
  CHART_TYPE_ALLOCATION_FOR_DRIVERS,
  // Accounting top group 1
  CHART_TYPE_TOTAL_PAYROLLS,
  CHART_TYPE_TOTAL_CLO_INVOICES,
  CHART_TYPE_TOTAL_FLEET_SERVICE,
  CHART_TYPE_TOTAL_EXPECTED_PROFIT,
  // Accounting top group 2
  CHART_TYPE_TOTAL_FUEL,
  CHART_TYPE_TOTAL_TOLL,
  CHART_TYPE_TOTAL_CARRIER_INVOICE,
  CHART_TYPE_TOTAL_CLOS_WITH_ZERO_RATE,
  // Accounting main group
  CHART_TYPE_PAYROLLS,
  CHART_TYPE_CLO_INVOICES_PER_MODE,
  CHART_TYPE_CARRIER_INVOICES_PER_MODE,
  // Accounting right group
  CHART_TYPE_NOT_INVOICED_CLOS,
  CHART_TYPE_PAYROLLS_PER_CHARGE,
  CHART_TYPE_CLO_INVOICE_STATUSES,
  CHART_TYPE_CARRIER_INVOICE_STATUSES,
  // Trailers top group 1
  CHART_TYPE_TOTAL_AVAILABLE_TRAILERS,
  CHART_TYPE_TOTAL_IN_SERVICE_TRAILERS,
  CHART_TYPE_AVERAGE_TRAILERS_IDLE_TIME,
  CHART_TYPE_TOTAL_OUT_OF_SERVICE_TRAILERS,
  // Trailers top group 2
  CHART_TYPE_TOTAL_ISSUES_FOUND,
  CHART_TYPE_AVERAGE_ISSUES_AGE,
  CHART_TYPE_AVERAGE_INSPECTION_TIME,
  CHART_TYPE_TOTAL_COMPLETED_INSPECTIONS,
  // Trailers main group
  CHART_TYPE_TRAILERS_BY_LOCATION,
  CHART_TYPE_TRAILERS_BY_IDLE_TIME,
  CHART_TYPE_IN_OR_OUT_OF_SERVICE_TRAILERS,
  // Trailers right group
  CHART_TYPE_ISSUES_BY_VENDOR,
  CHART_TYPE_TRAILERS_BY_CARRIER,
  CHART_TYPE_OPENED_ISSUES_BY_PRIORITY,
};
